import React from "react";
import { observer } from "mobx-react";
import { Button, Popover } from "antd";
import { WeaRightMenu, WeaInput, WeaNewScroll, WeaSelect } from "ecCom";
import { stickMsgType, cancelStickMsgType } from "../../apis/index";

import WeaLocaleProvider from "../../../../ecology9/wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

@observer
class RightListItem extends React.Component {
  onItemClick = () => {
    const { onItemClick, data } = this.props;
    if (typeof onItemClick === "function") {
      onItemClick(data);
    }
  };
  onContextMenu = () => {
    const { onContextMenu, data } = this.props;
    if (typeof onContextMenu === "function") {
      onContextMenu(data);
    }
  };
  render() {
    const { cls, data } = this.props;
    const { id, name, count, icon } = data;
    // 暂时不展示 [全部] 标签
    if (id === "0") {
      return null;
    }
    return (
      <li
        className={cls}
        onClick={this.onItemClick}
        onContextMenu={this.onContextMenu}
      >
        <div>
          <i className={"icon"}>
            <img src={icon} alt="" />
          </i>
          <span class="title wea-f12" title={name}>
            {name}
          </span>
          {Number(count) > 0 && <span className="num">{count}</span>}
        </div>
      </li>
    );
  }
}

@observer
class MsgTypePanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hoverId: "",
      currentIds: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rightList.length !== this.props.rightList.length &&
      this.state.hoverId === ""
    ) {
      this.setState({
        currentIds: nextProps.rightList
          .filter(item => item.rank && item.rank !== "")
          .map(item => item.id)
          .reverse()
      });
    }
  }

  stickTop = () => {
    const { rightList } = this.props;
    const { currentIds, hoverId } = this.state;
    if (currentIds.includes(hoverId)) {
      currentIds.splice(currentIds.indexOf(hoverId), 1);
      cancelStickMsgType({ id: hoverId });
    } else {
      currentIds.push(hoverId);
      stickMsgType({ id: hoverId });
    }
    this.setState({ currentIds });
    currentIds.reverse();
    let newRightList = [];
    for (let i = 0; i < currentIds.length; i++) {
      for (let j = 0; j < rightList.length; j++) {
        if (currentIds[i] === rightList[j].id) {
          newRightList.push(rightList[j]);
          rightList.splice(j, 1);
          break;
        }
      }
    }
    currentIds.reverse();
    let tempArray = rightList;
    tempArray = tempArray.sort((a, b) => {
      return new Date(b.time) - new Date(a.time);
    });
    newRightList = newRightList.concat(...tempArray);
    this.props.setState({
      rightList: newRightList
    });
  };

  onInputChange = e => {
    this.props.setState({
      keyword: e
    });
  };

  onSelectChange = v => {
    this.props.setState({
      moduleId: v
    });
  };

  onPressEnter = () => {
    this.props.advancedSearch("search");
  };

  onKeyworIconClick = () => {
    this.props.setState({
      searchVisible: !this.props.searchVisible
    });
  };

  doSearch = () => {
    this.props.advancedSearch("search");
  };

  doReset = () => {
    this.props.advancedSearch("reset");
  };

  onRightListItemClick = item => {
    if (!this.props.loading) {
      this.props.setState({
        flag: true,
        newMsgValue: "none",
        current: item.id
      });
      this.props.changeRight(item.id, 0, 0, item);
    }
  };

  customMenu = data => {
    const res = data.splice(1, 2);
    // ie 9 兼容问题
    data.length = 1;
  };

  onContextMenu = item => {
    this.setState({
      hoverId: item.id
    });
  };

  render() {
    const { options, moduleId, viewAttr, rightList, current } = this.props;
    const { currentIds, hoverId } = this.state;
    const menu = [
      {
        key: "1",
        content: currentIds.includes(hoverId)
          ? getLabel("510155", "取消置顶")
          : getLabel("510077", "置顶消息"),
        onClick: this.stickTop
      }
    ];
    let scrollHeight =
      this.props.offsetHeight === 0 ? 585 : 585 + this.props.offsetHeight - 80;
    if (window.innerHeight < 900) {
      scrollHeight = 450;
    }
    return (
      <div>
        <div className="wea-messageCenter-rightList">
          <div className="search-panel">
            <Popover
              overlayClassName="wea-messageCenter-custom-popover"
              // overlayStyle={{ width: 168 }}
              content={
                <div className="wea-messageCenter-rightList-advancedSearch">
                  <p> {getLabel("504403", "消息种类")}: </p>
                  <div>
                    <WeaInput
                      value={this.props.keyword}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <p> {getLabel("19049", "模块")}: </p>
                  {/* 由于 WeaSelect的设计在父级宽度 -3px， 导致这里只能 148 + 1 = 151 :( */}
                  <div>
                    <WeaSelect
                      style={{ width: 180 }}
                      options={options}
                      value={moduleId}
                      viewAttr={viewAttr}
                      widthMatchOptions={true}
                      onChange={this.onSelectChange}
                    />
                  </div>
                  <div
                    style={{
                      margin: "18px -10px 0",
                      height: 1,
                      background: "#ebebeb"
                    }}
                  />
                  <div style={{ textAlign: "center", marginBottom: 0 }}>
                    <Button
                      className="advanced-button"
                      onClick={this.doSearch}
                      type="primary"
                    >
                      {getLabel("388113", "搜索")}
                    </Button>
                    &emsp;
                    <Button className="advanced-button" onClick={this.doReset}>
                      {getLabel("2022", "重置")}
                    </Button>
                  </div>
                </div>
              }
              placement="bottom"
              visible={this.props.searchVisible}
            >
              <div>
                <WeaInput
                  value={this.props.keyword}
                  placeholder={getLabel("500351", "请输入关键字")}
                  onChange={this.onInputChange}
                  onPressEnter={this.onPressEnter}
                />
                <i
                  onClick={this.onKeyworIconClick}
                  className={
                    this.props.keyword !== "" || this.props.moduleId !== ""
                      ? "icon-coms-screen2"
                      : "icon-coms-screen"
                  }
                />
              </div>
            </Popover>
          </div>
          <WeaRightMenu datas={menu} customMenu={this.customMenu}>
            <WeaNewScroll height={scrollHeight}>
              <ul>
                {rightList.length > 0 &&
                  rightList.map(item => (
                    <RightListItem
                      cls={`item ${item.id === current ? "active" : ""} ${
                        currentIds.includes(item.id) ? "sticky" : ""
                      }`}
                      data={{ ...item }}
                      onItemClick={this.onRightListItemClick}
                      onContextMenu={this.onContextMenu}
                    />
                  ))}
              </ul>
            </WeaNewScroll>
          </WeaRightMenu>
        </div>
      </div>
    );
  }
}

export default MsgTypePanel;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/msg-type-panel.js